import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { setSelectedTag } from '../../../../store/prompt/slice';
import styles from './TagFilter.module.scss';
import { PromptTag } from '../../../../store/prompt/types';

export const useFilteredPrompts = () => {
  const selectedTag = useSelector((state: RootState) => state.prompt.selectedTag);
  const prompts = useSelector((state: RootState) => state.prompt.prompts);

  return selectedTag ? prompts.filter((prompt) => prompt.tag === selectedTag) : prompts;
};

const TagFilter: React.FC = () => {
  const dispatch = useDispatch();
  const selectedTag = useSelector((state: RootState) => state.prompt.selectedTag);
  const prompts = useSelector((state: RootState) => state.prompt.prompts);

  const handleTagChange = (value: string) => {
    dispatch(setSelectedTag(value as PromptTag));
  };

  return (
    <div className={styles.container}>
      <select
        className={styles.select}
        value={selectedTag || ''}
        onChange={(e) => handleTagChange(e.target.value)}
      >
        <option className={styles.option} value="">
          all ({prompts.length})
        </option>
        {Object.values(PromptTag).map((tag) => {
          const count = prompts.filter((prompt) => prompt.tag === tag).length;
          return (
            <option className={styles.option} key={tag} value={tag}>
              {tag} ({count})
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default TagFilter;
